import React, { Component } from 'react';

const EnterKeyCode = 13;

export class Search extends Component {
	constructor() {
		super();

		this.handleInvalid = this._handleInvalid.bind(this);
		this.handleBlur = () => {
			this.setState({ focused: false });
		};
		this.handleFocus = () => {
			this.setState({ focused: true });
		};

		this.state = {
			focuse: false,
			searchTerm: ''
		};

		this.handleChange = (event) => {
			this.setState({
				searchTerm: event.target.value
			});
		};

		this.onSearchClick = (e) => {
			this.props.onSearchProject({
				searchTerm: this.state.searchTerm
			});
		};

		this.onKeyUp = (e) => {
			this._handleInvalid(e);
			if (e.keyCode === EnterKeyCode && e.target.validity.valid) {
				this.onSearchClick();
			}
		};
	}

	_handleInvalid(e) {
		e.target.setCustomValidity('');
		if (!e.target.validity.valid) {
			if (!e.target.value) {
				e.target.setCustomValidity('Pole jest wymagane');
			} else if (e.target.value.length < 3) {
				e.target.setCustomValidity('Minimalna długość zapytania to 3 znaki');
			}
		}
	}

	render() {
		const { focused } = this.state;

		return (
			<div className="search">
				<form onSubmit={this.onSearchClick}>
					<label htmlFor="search__input" className="hidden">
						Szukaj
					</label>
					<input
						className={`search__input${focused ? ' search__input--widther' : ''}`}
						placeholder="Szukaj"
						name="phrase"
						required
						onInvalid={this.handleInvalid}
						onFocus={this.handleFocus}
						onBlur={this.handleBlur}
						onChange={this.handleChange}
						onKeyUp={this.onKeyUp}
						title="Wpisz frazę"
						pattern=".{3,}"
					/>
					<button type="submit" className="search__button" title="Wyszukaj hasła">
						<i className="fa fa-search" aria-hidden="true" />
					</button>
				</form>
			</div>
		);
	}
}
